function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.00292969C4.486 0.00292969 0 4.48893 0 10.0029C0 15.5159 4.486 20.0029 10 20.0029C15.514 20.0029 20 15.5159 20 10.0029C20 4.48893 15.514 0.00292969 10 0.00292969ZM9 15.0029H5V6.00293H9V15.0029ZM15 15.0029H11V6.00293H15V15.0029Z",
  fill: "#003056"
});

function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.afe80c99.svg";
export { ForwardRef as ReactComponent };